class NewsListSearch {

  constructor($elm) {
    this.searchString = '';
    this.filterValues = {
      category: []
    };
    this.initDomElements($elm);
    this.initSearchForm();
    this.initCategoryFilter();
  }

  initDomElements($elm) {
    this.domElements = {};
    this.domElements.main = $elm;
    this.domElements.searchForm = this.domElements.main.find(
        '.news-list__search');
    this.domElements.searchFormInput = this.domElements.searchForm.find(
        'input[type="text"]');
    this.domElements.searchResultsEmptyAdvice = this.domElements.main.find(
        '.news-list__empty-advice');
    this.domElements.searchResultsItems = [];
    this.domElements.main.find('.news-list__item').
        each((index, element) => {
          this.domElements.searchResultsItems.push($(element));
        });
    this.domElements.categoryFilter = this.domElements.main.find('.news-list__category-filter');
  }

  initCategoryFilter() {
    const $input = this.domElements.categoryFilter.find('input');
    $input.on('change', this.onChangeFilter.bind(this));
  }

  onChangeFilter() {
    console.log('onChangeFilter');
    this.readFilterValues();
    this.filterItems();
    console.log(this.filterValues);
  }

  readFilterValues() {
    this.readFilterValueCheckboxes(this.domElements.categoryFilter);
  }

  readFilterValueCheckboxes($filter) {
    const filterName = $filter.data('filterName');
    const values = [];

    $filter.find('input').each((index, input) => {
      const $input = $(input);
      if ($input.prop('checked')) {
        values.push($input.val());
      }
    });

    this.filterValues[filterName] = {
      type: 'checkbox',
      values: values
    };
  }

  initSearchForm() {
    this.domElements.searchForm.on('submit', (event) => {
      event.preventDefault();
      this.searchString = this.domElements.searchFormInput.val();
      this.filterItems();
    });
  }

  filterItems() {
    let matchedItems = [];
    if (this.searchString === '') {
      matchedItems = this.domElements.searchResultsItems;
    } else {
      matchedItems = this.domElements.searchResultsItems.filter(
          ($item) => {
            return this.isSearchItemMatchString($item, this.searchString);
          });
    }

    /* categories: */
    if (this.filterValues.category.values && this.filterValues.category.values.length > 0) {
      matchedItems = matchedItems.filter(
          ($item) => {
            let matched = false;
            for (const category of this.filterValues.category.values) {
              if (this.isSearchItemMatchCategory($item, category)) {
                matched = true;
              }
            }
            return matched;
          });
    }


    if (matchedItems.length === 0) {
      this.showNoItemsAdvice();
    } else {
      this.hideNoItemsAdvice();
    }

    this.showMatchedItems(matchedItems);
  }

  isSearchItemMatchString($item, string) {
    let matched = false;
    const text = this.getElementTexts($item);
    if (text.search(string.toLowerCase()) > -1) {
      matched = true;
    }
    return matched;
  }

  isSearchItemMatchCategory($item, category) {
    let matched = false;
    const categories = $item.data('filter-category').split(',');
    if (categories.indexOf(category) > -1) {
      matched = true;
    }
    return matched;
  }

  getElementTexts($element) {
    let text = '';
    $element.find('*').each((index, elm) => {
      text += $(elm).text() + ' ';
    });
    return text.toLowerCase();
  }

  showMatchedItems(matchedItems) {
    for (const $item of this.domElements.searchResultsItems) {
      this.hideItem($item);
    }

    for (const $item of matchedItems) {
      this.showItem($item);
    }
  }

  showItem($item) {
    $item.show();
  }

  hideItem($item) {
    $item.hide();
  }

  showNoItemsAdvice() {
    this.domElements.searchResultsEmptyAdvice.fadeIn();
  }

  hideNoItemsAdvice() {
    this.domElements.searchResultsEmptyAdvice.hide();
  }
}

export default NewsListSearch;
